<template>
    <div>
        <div class="page-wrapper">
			<NuxtLoadingIndicator :duration="1000" :throttle="10000" :height="4" />
            <TopNotice></TopNotice>
            <header-default></header-default>
            <slot></slot>
            <footer-default></footer-default>
            <button id="scroll-top" ref="scrollTop" title="Back to Top" @click.prevent="scrollTop">
                <i class="icon-arrow-up"></i>
            </button>
        </div>
        <div class="mobile-menu-overlay" @click="hideMobileMenu"></div>
        <mobile-menu></mobile-menu>
    </div>
</template>

<script>
import TopNotice from '~/components/partial/top-notice/TopNotice';
import HeaderDefault from '~/components/partial/headers/HeaderDefault';
import FooterDefault from '~/components/partial/footers/FooterDefault';
import MobileMenu from '~/components/partial/home/MobileMenu';
import { isSafariBrowser, isEdgeBrowser } from '~/utilities/common';

export default {
	components: {
		TopNotice,
		HeaderDefault,
		FooterDefault,
		MobileMenu
	},
	mounted: function() {
		let scrollTop = this.$refs.scrollTop;
		document.addEventListener(
			'scroll',
			function() {
				if (window.pageYOffset >= 400) {
					scrollTop.classList.add('show');
				} else {
					scrollTop.classList.remove('show');
				}
			},
			false
		);
	},
	methods: {
		scrollTop: function() {
			if (isSafariBrowser() || isEdgeBrowser()) {
				let pos = window.pageYOffset;
				let timerId = setInterval(() => {
					if (pos <= 0) clearInterval(timerId);
					window.scrollBy(0, -120);
					pos -= 120;
				}, 1);
			} else {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}
		},
		hideMobileMenu: function() {
			document.querySelector('body').classList.remove('mmenu-active');
		}
	}
};
</script>

<style>
	.page-enter-active,
	.page-leave-active {
	  transition: all 0.4s;
	}
	.page-enter-from,
	.page-leave-to {
	  opacity: 0;
	  filter: blur(1rem);
	}
</style>